import React from 'react';
import ReactModal from 'react-modal';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../Modal';
import { Header, Text } from 'common/components/texts/Texts';
import { useTranslation } from 'react-i18next';
import Button from 'common/components/button/Button';

export type ImportFamilyImagesResult = 'add' | 'replace' | 'cancel';

type Props = {
    title: string;
    familyName: string;
    imageCount: number;
    hasExistingImages: boolean;
    onClose: (result: ImportFamilyImagesResult) => void;
} & ReactModal.Props;

const ImportFamilyImagesModal: React.FC<Props> = ({ title, familyName, imageCount, hasExistingImages, onClose, ...props }: Props) => {
    const { t } = useTranslation();

    const message = t('elements.modals.import_family_images_message', { familyName, count: imageCount });

    return (
        <Modal {...props} style={{ content: { minWidth: 450, maxWidth: 500 } }} onRequestClose={() => onClose('cancel')}>
            <div>
                <ModalHeader>
                    <Header>{title.toUpperCase()}</Header>
                </ModalHeader>
                <ModalBody>
                    <Text>{message}</Text>
                </ModalBody>
                <ModalFooter className="text-right" style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                    <Button fw variant="secondary" onClick={() => onClose('cancel')}>
                        {t('elements.modals.import_cancel')}
                    </Button>
                    {hasExistingImages && (
                        <Button fw variant="secondary" onClick={() => onClose('replace')}>
                            {t('elements.modals.import_replace')}
                        </Button>
                    )}
                    <Button onClick={() => onClose('add')}>
                        {hasExistingImages ? t('elements.modals.import_add') : t('elements.modals.import_confirm')}
                    </Button>
                </ModalFooter>
            </div>
        </Modal>
    );
};

export default ImportFamilyImagesModal;
